import { Icon } from '@iconify/react'
import { createFileRoute } from '@tanstack/react-router'
import { useRouter } from '@tanstack/react-router'
import * as React from 'react'

import noPermission from '~in-app/assets/NoPermission.jpg'
import { Button } from '~in-app/components/shadcn-ui'

export const Route = createFileRoute('/console/no-permission')({
  component: DefaultNoPermission,
  staticData: {
    privileges: [],
  },
})

function DefaultNoPermission() {
  const router = useRouter()

  const onBack = () => router.history.back()

  return (
    <div className="container mx-auto h-full">
      <div className="flex size-full items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <div className="flex flex-col gap-4 sm:w-1/2">
            <div className="text-center text-error-500 md:text-start">
              403 Access Denied
            </div>

            <div className="text-center text-xl font-bold text-error-500 md:text-start">
              {' '}
              Sorry, you don't have permission to access this page.
            </div>

            <div className="text-center text-muted-foreground md:text-start">
              Please contact the admin if you have any questions.
            </div>

            <Button
              hasIcon
              className="p-0 md:justify-start"
              variant="link"
              onClick={onBack}
            >
              <Icon
                height="16"
                icon="lucide:arrow-left"
                width="16"
              />
              Back
            </Button>
          </div>

          <img
            alt="404-not-found"
            className="rounded-md shadow-md"
            height={400}
            src={noPermission}
            style={{ objectFit: 'contain' }}
            width={400}
          />
        </div>
      </div>
    </div>
  )
}
